import { Routes } from '@angular/router';

import { FourOhFourComponent } from './404.component';
import { AppComponent } from './app.component';
import { InstitutionContextResolver } from './institution-context.resolver';

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: AppComponent,
    resolve: { context: InstitutionContextResolver },
    children: [
      {
        path: 'search',
        loadChildren: () =>
          import('./search/search.routes').then((m) => m.SEARCH_ROUTES),
      },
      {
        path: 'scholar',
        loadChildren: () =>
          import('./scholar/scholar.routes').then((m) => m.SCHOLAR_ROUTES),
      },
      {
        path: 'contact',
        loadChildren: () =>
          import('./contact/contact.routes').then((m) => m.CONTACT_ROUTES),
      },
      {
        path: 'dashboard',
        redirectTo: '',
        pathMatch: 'full',
      },
      {
        path: '',
        loadChildren: () =>
          import('./dashboard/dashboard.routes').then(
            (m) => m.DASHBOARD_ROUTES,
          ),
      },
      { path: '**', component: FourOhFourComponent },
    ],
  },
];
